import script from "./pageHoleWithoutHeader.vue?vue&type=script&setup=true&lang=js"
export * from "./pageHoleWithoutHeader.vue?vue&type=script&setup=true&lang=js"

import "./pageHoleWithoutHeader.vue?vue&type=style&index=0&id=0541a236&scoped=true&lang=css"

import exportComponent from "/home/steffen/Projekte/clubadmin/frontend/homepage/gc-schoenbuch/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0541a236"]])

export default __exports__